import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

/**
 * This guard tries to initiate an oauth2 login, and redirects to the index if it fails.
 * Used as a method of IDP initiated authentication.
 */
@Injectable({
    providedIn: 'root'
})
export class AutoLoginGuard implements CanActivate {
    constructor(
        private oauthService: OAuthService,
        private router: Router) {
    }

    public canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return new Observable<boolean>(subscriber => this.invertAuth(subscriber));
    }

    private invertAuth(subscriber: Subscriber<boolean>) {
        this.oauthService.initLoginFlow();
        this.router.navigateByUrl('');
    }
}
